import React from 'react';
import { DollarSign, Percentage } from '../../../../../components/atoms/icons';
import Stepper from '../../../../../components/molecules/steppers';

interface Props {
    currentMode: 1 | 2;
    setCurrentMode: React.Dispatch<1 | 2>
}

function CommissionType(props: Props) {
  const { currentMode, setCurrentMode } = props;
  const renderFixPrice = () => (
    <div className="d-flex align-items-center">
      <DollarSign width={23} />
      <div className="fz-14" style={{ marginTop: '1px' }}>Fix Price</div>
    </div>
  );

  const renderPercentage = () => (
    <div className="d-flex align-items-center">
      <Percentage width={23} />
      <div className="fz-14" style={{ marginTop: '1px', marginLeft: '2px' }}>Percentage</div>
    </div>
  );

  return (
    <Stepper.Switch
      currentMode={currentMode}
      setCurrentMode={setCurrentMode}
      content={{
        1: renderPercentage(),
        2: renderFixPrice(),
      }}
      label="Commision Type"
      className="mb-4"
    />
  );
}

export default CommissionType;
